









































import moment from "moment"
import {computed, defineComponent, ref, toRefs, watch} from "@vue/composition-api"

export default defineComponent({
  name: 'TimerPie',
  props: {
    expiresAt: {
      type: String,
      required: true
    }
  },
  setup(props) {
    const {expiresAt} = toRefs(props)
    const duration = ref(0)
    const timePassed = ref(0)
    watch(expiresAt, (newValue: string) => {
      duration.value = moment.duration(moment(newValue).diff(moment())).asSeconds()
      timePassed.value = 0
    })
    setInterval(() => {
      timePassed.value += .1
    }, 100)
    const progress = computed(() => Math.min(100, 100 * (timePassed.value / duration.value)))

    const progressStyle = computed(() => progress.value <= 50 ? {
      'transform': `rotate(${(100 - (progress.value - 50)) / 100 * 360}deg)`,
      '--color': '#69a18d' // foreground
    } : {
      'transform': `rotate(${(100 - progress.value) / 100 * 360}deg)`,
      '--color': '#344244' // background
    })

    return {
      progressStyle
    }
  },
})
